import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandIcon from '@material-ui/icons/ExpandMore';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Paginator from '../../../components/Paginator/Paginator';
import ReplaceContact from '../../../components/Replace/ReplaceContact/ReplaceContact';
import DocumentStyleArea from '../../../components/DocumentStyleArea/DocumentStyleArea';

import { Formik } from 'formik';
import { find } from 'lodash-es';
import { object, string } from 'yup';
import { getString } from '../../../helpers/stringHelpers';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

const stringsComponent = 'helpCenter';
class FAQs extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      keywords: '',
      topic: 'all',
      currentPage: 1,
      itemsPerPage: 10,
      hasSearched: false,
    };

    this.handlePaginationChange = this.handlePaginationChange.bind(this);
    this.handleFAQClick = this.handleFAQClick.bind(this);
  }

  handlePaginationChange(currentPage) {
    this.setState({ currentPage: currentPage });
  }

  handleFAQClick(i) {
    const { gaEvent } = this.props;

    gaEvent('FAQ', 'Click', this.refs['faq' + i].props.children);
  }

  render() {
    const { classes, questions, toggleContactModal, gaEvent } = this.props;

    const { keywords, topic, currentPage, itemsPerPage, hasSearched } =
      this.state;

    const selectedTopic = find(portalTopics, { ID: topic });
    const selectedTopicName = selectedTopic ? selectedTopic.Name : 'All';

    const searchTerms = keywords ? keywords : selectedTopicName;

    const showDefaultResults =
      topic == 'all' && keywords.length == 0 && !hasSearched;

    const resultsTitle = showDefaultResults
      ? getString(stringsComponent, 'POPULAR_FAQS_HEADING')
      : `${getString(
          stringsComponent,
          'SEARCH_RESULTS_HEADING'
        )} "${searchTerms}"`;

    const filteredQuestions = questions.filter((item) => {
      const words = keywords.toLowerCase().split(' ');
      let matchFound = true;
      // Show pinned items if no search performed.
      if (showDefaultResults) {
        return item.Pinned;
      } else {
        for (const word of words) {
          if (word) {
            const regex = new RegExp(`\\b${word}[s]?\\b`, 'g');
            if (
              !regex.test(item.Title.toLowerCase()) &&
              !regex.test(item.Content.toLowerCase())
            ) {
              matchFound = false;
              break;
            }
          }
        }
        if (!isNaN(topic) && item.TopicID != topic) {
          matchFound = false;
        }
      }
      return matchFound;
    });

    // Paginate items.
    const lastItemIndex = currentPage * itemsPerPage;
    const firstItemIndex = lastItemIndex - itemsPerPage;
    const currentQuestions = filteredQuestions.slice(
      firstItemIndex,
      lastItemIndex
    );

    return (
      <Card className={`Card`}>
        <CardContent className={classes.cardContent}>
          <Formik
            initialValues={{ keywords: '', topic: 'all' }}
            isInitialValid={true}
            onSubmit={(values, { resetForm }) => {
              this.setState(values);
              this.setState({ currentPage: 1, hasSearched: true });
              if (values.keywords.length) {
                gaEvent('Help_Keywords', 'Submit', values.keywords);
              }
              const submittedTopic = find(portalTopics, { ID: values.topic });
              if (submittedTopic) {
                gaEvent('Help_Topic', 'Submit', submittedTopic.Name);
              }
            }}
          >
            {(props) => {
              const {
                handleChange,
                handleSubmit,
                setFieldValue,
                isValid,
                values,
              } = props;
              return (
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.handleSubmit(e);
                  }}
                >
                  <Grid container spacing={16}>
                    <Grid item xs={12} sm={6} md={12} lg={6}>
                      <Typography className={classes.label}>
                        <label htmlFor="keywords">
                          {getString(stringsComponent, 'SEARCH_LABEL')}
                        </label>
                      </Typography>
                      <TextField
                        variant="outlined"
                        id="keywords"
                        name="keywords"
                        value={values.keywords}
                        onChange={handleChange}
                        placeholder={getString(
                          stringsComponent,
                          'SEARCH_PLACEHOLDER'
                        )}
                        fullWidth
                        inputProps={{
                          className: `${classes.searchInput}`,
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={12} lg={6}>
                      <Typography className={classes.label}>
                        <label htmlFor="topic">
                          {getString(stringsComponent, 'TOPIC_LABEL')}
                        </label>
                      </Typography>
                      <Select
                        onChange={handleChange}
                        value={values.topic}
                        input={
                          <OutlinedInput
                            name="topic"
                            id="topic"
                            labelWidth={0}
                          />
                        }
                        fullWidth
                        MenuProps={{
                          anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'left',
                          },
                          getContentAnchorEl: null,
                        }}
                        IconComponent={ExpandIcon}
                      >
                        <MenuItem value="all">
                          {getString(stringsComponent, 'TOPIC_PLACEHOLDER')}
                        </MenuItem>
                        {portalTopics.map((option, i) => {
                          return (
                            <MenuItem key={i} value={option.ID}>
                              {option.Name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </Grid>
                  </Grid>
                  <div className={classes.buttonsContainer}>
                    <Grid container spacing={16}>
                      <Grid item xs={6} className={classes.gridItemRight}>
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={() => {
                            this.setState({
                              keywords: '',
                              topic: 'all',
                              currentPage: 1,
                              hasSearched: false,
                            });
                            setFieldValue('keywords', '');
                            setFieldValue('topic', 'all');
                          }}
                          className={classes.button}
                        >
                          {getString(stringsComponent, 'CLEAR_BUTTON_LABEL')}
                        </Button>
                      </Grid>
                      <Grid item xs={6}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleSubmit}
                          disabled={!isValid}
                          className={classes.button}
                          type="submit"
                        >
                          {getString(stringsComponent, 'SEARCH_BUTTON_LABEL')}
                        </Button>
                      </Grid>
                    </Grid>
                  </div>
                </form>
              );
            }}
          </Formik>
          <Typography variant="h3" className={classes.resultsHeading}>
            {resultsTitle}
          </Typography>
          <Divider />
          {currentQuestions.map((faq, i) => (
            <div key={faq.ID}>
              {/* @todo Make questions a new component, and update questions in
                HelpCard and this FAQ component to use the new question component. */}
              <ExpansionPanel
                className={classes.expansionPanel}
                CollapseProps={{ unmountOnExit: true }}
                onClick={() => this.handleFAQClick(i)}
              >
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon className={classes.expandIcon} />}
                >
                  <Typography
                    className={classes.expansionPanelTitle}
                    ref={'faq' + i}
                  >
                    {faq.Title}
                  </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails
                  className={classes.expansionPanelDetails}
                >
                  <Typography
                    className={classes.expansionPanelContent}
                    component="div"
                  >
                    {
                      <ReplaceContact
                        content={faq.Content}
                        action={toggleContactModal}
                        isLink={true}
                      />
                    }
                  </Typography>
                </ExpansionPanelDetails>
              </ExpansionPanel>
              <Divider />
            </div>
          ))}
          {!currentQuestions.length && (
            <div className={classes.noResultsContainer}>
              <DocumentStyleArea
                content={
                  <ReplaceContact
                    content={portalContent.HELP_CENTER_NO_RESULTS_MESSAGE}
                    action={toggleContactModal}
                    isLink={true}
                  />
                }
              />
            </div>
          )}
          {filteredQuestions.length > itemsPerPage && (
            <div className={classes.paginatorContainer}>
              <Paginator
                onChange={this.handlePaginationChange}
                itemsCount={filteredQuestions.length}
                itemsPerPage={itemsPerPage}
                currentPageOverride={currentPage}
              />
            </div>
          )}
        </CardContent>
      </Card>
    );
  }
}

FAQs.propTypes = {
  classes: PropTypes.object.isRequired,
  questions: PropTypes.array,
  toggleContactModal: PropTypes.func.isRequired,
  gaEvent: PropTypes.func.isRequired,
};

FAQs.defaultProps = {
  questions: [],
};

export default withStyles(styles)(FAQs);
